import react from "react";

type ExamFeatureFlags = {
  // useNewD3Graphs?: boolean;
};
export const ExamFeatureContext = react.createContext<ExamFeatureFlags>({});
